export const useRecentStore = defineStore("recent", () => {
  const profile = useProfileStore();
  const songNumbers = useLocalStorage<string[]>(
    "recent-song-numbers-viewed",
    [],
  );

  function onViewSongNumber(songNumber: string) {
    if (!profile.profile?.signedIn) {
      return;
    }
    const index = songNumbers.value.findIndex((s) => s === songNumber);
    if (index >= 0) {
      songNumbers.value.splice(index, 1);
    }
    songNumbers.value.unshift(songNumber);
  }

  return {
    songNumbers,
    onViewSongNumber,
  };
});
